import { TimelineMax, TweenLite } from "gsap/all";
import SimpleScrollbar from "simple-scrollbar";
import { shuffleArray } from "../helpers";
const getCalculatedPercent = (value, isFalsy = false) => {
    const result = isFalsy ? 100 - value : value;
    switch (result) {
        case 0:
            return { result, value: 0 };
        case 25:
            return { result, value: 10 };
        case 50:
            return { result, value: 20 };
        case 75:
            return { result, value: 50 };
        default:
            return { result, value: 100 };
    }
};
export default class Questions {
    constructor({ data }) {
        this.url = "/questions.json";
        this.data = data;
        this.currentIndex = 0;
        this.results = {};
        this.isAllAnswersCorrect = true;
        this.phase = 0;
        this.questionsEl = document.querySelector(".js-questions");
        this.questionsBlockEl = document.querySelector(".js-questions-block");
        this.questionsMessages = Array.from(document.querySelectorAll(".js-questions-messages > div")).map(item => Array.from(item.querySelectorAll('p')).map(el => el.innerHTML));
        this.animatedItems = Array.from(document.querySelectorAll(".js-questions .js-animate-block"));
        this.counterEl = document.querySelector(".js-questions-counter");
        this.nextEl = document.querySelector(".js-questions-go-next");
        this.currentEl = this.counterEl.querySelector(".js-current");
        this.totalEl = this.counterEl.querySelector(".js-total");
        this.answersEl = document.querySelector(".js-menu-answers");
        this.studyScreenEl = document.querySelector(".js-study");
        this.goNext = this.goNext.bind(this);
        this.goToResults = null;
    }
    reset() {
        this.currentIndex = 0;
        this.phase = 0;
        this.isAllAnswersCorrect = true;
        this.results = {};
        this.questionElements = [];
        this.questionIds = [];
    }
    destroy() {
        this.reset();
        this.studyScreenEl.classList.remove("is-warn-shown");
        TweenLite.set(['.js-study-1 .js-animate-block', '.js-study-2 .js-animate-block', '.js-questions .js-animate-block'], { autoAlpha: 0 });
        TweenLite.set(this.currentEl, { y: 0 });
    }
    /* DO NOT REMOVE */
    /* TODO: create handler */
    /* eslint-disable-next-line */
    onChange(calculatedPercent, backward) { }
    renderAnswers(data) {
        this.answersEl.innerHTML = '';
        this.answersArray = data.map(({ item: { label } }, index) => {
            const div = document.createElement("div");
            div.innerHTML = `
        <button class="js-menu-answers-block">
          <div>0${index + 1}</div>
          <div>
            <span>${this.data.Correct}</span>
            <span>${this.data.Incorrect}</span>
            <div>${label}</div>
          </div>
        </button>
      `;
            div.setAttribute("data-index", index.toString());
            this.answersEl.appendChild(div);
            return div;
        });
        if (!this.isHandlersInitialized) {
            SimpleScrollbar.initEl(this.answersEl.parentElement.parentElement);
        }
        setTimeout(() => {
            const answers = document.querySelectorAll('.answer');
            Array.from(answers).forEach((item) => item.setAttribute('style', `height: ${item.offsetHeight}px;`));
        }, 200);
    }
    setCurrentQuestionValue() {
        this.currentEl.innerHTML = (this.currentIndex + 1).toString();
    }
    goNext(target, percent) {
        if (this.isAnimating) {
            return;
        }
        this.isAnimating = true;
        const nextIndex = this.currentIndex + 1;
        const prevEl = this.questionElements[this.currentIndex];
        const nextEl = this.questionElements[nextIndex];
        const { value } = prevEl.dataset;
        const { result: calculatedPercent, value: result } = getCalculatedPercent(percent, value === "0");
        this.results[this.currentIndex + 1] = result;
        const isCorrect = result === 100;
        const isQuestionFalsy = value === '0';
        if (isQuestionFalsy) {
            this.answersArray[this.currentIndex].classList.add("is-invalid");
        }
        if (!isCorrect) {
            this.isAllAnswersCorrect = false;
            this.phase += 1;
        }
        window.analytics.trackAction(`screen_${this.currentIndex + 1}_answer_${calculatedPercent}`);
        window.analytics.trackAction(`stats_qa_${this.questionIds[this.currentIndex]}_${calculatedPercent}`);
        if (calculatedPercent === 0) {
            console.log(`${result}%`, 'is-wrong');
            this.questionsEl.classList.add('is-wrong');
        }
        else if (calculatedPercent === 25) {
            console.log(`${result}%`, 'is-almost-wrong');
            this.questionsEl.classList.add('is-almost-wrong');
        }
        else if (calculatedPercent === 50) {
            console.log(`${result}%`, 'is-dont-know');
            this.questionsEl.classList.add('is-dont-know');
        }
        else if (calculatedPercent === 75) {
            console.log(`${result}%`, 'is-almost-right');
            this.questionsEl.classList.add('is-almost-right');
        }
        else {
            console.log(`${result}%`, 'is-correct');
            this.questionsEl.classList.add('is-correct');
        }
        const isLastElement = this.currentIndex === this.questionElements.length;
        const msgDuration = isLastElement ? 0 : this.questionsMessages[percent / 25][this.currentIndex].length * 0.05;
        this.onChange(result, false);
        const tl = new TimelineMax({
            paused: true,
            onStart: () => {
                this.currentIndex += 1;
            },
            onComplete: () => {
                if (this.currentIndex === this.questionElements.length) {
                    this.isAnimating = false;
                    this.goToResults(this.results, this.phase);
                    TweenLite.set(this.currentEl, { y: '100%' });
                    this.timeline.container.classList.remove('is-choosed');
                    return;
                }
                TweenLite.set(nextEl, { display: "flex" });
                new TimelineMax()
                    .to(nextEl, 0.3, {
                    autoAlpha: 1,
                    onStart: () => {
                        nextEl.classList.add("is-active");
                        prevEl.classList.remove("is-active");
                        this.setCurrentQuestionValue();
                        TweenLite.fromTo(this.currentEl, 0.3, { y: '100%' }, { y: '0%' });
                    },
                    onComplete: () => {
                        TweenLite.set(prevEl, { display: "none", autoAlpha: 0 });
                        this.isAnimating = false;
                        window.analytics.trackPage(`screen_${this.currentIndex + 1}_question`);
                    }
                })
                    .staggerFromTo(['.js-questions .js-questions-item', '.js-questions-item .js-animate-block'], 0.4, { autoAlpha: 0, y: 30 }, { autoAlpha: 1, y: 0 }, 0.2, '-=0.2');
            },
        }).to([prevEl, this.timeline.container.querySelectorAll('button:not(.is-active)')], 0.4, {
            autoAlpha: 0,
            // onStart: () => this.questionsEl.classList.add('is-message-shown'),
            onComplete: () => {
                TweenLite.set(prevEl, { display: "none", autoAlpha: 0 });
                this.questionsEl.classList.add('is-message-shown');
            },
        });
        this.questionsEl.dataset.question = (this.currentIndex + 1).toString();
        const warningTl = new TimelineMax({
            paused: true,
        })
            .to(".js-questions-messages", 0.4, { autoAlpha: 1 })
            .to([".js-questions-messages", this.timeline.container.querySelector('button.is-active')], 0.4, { autoAlpha: 0 }, `+=${msgDuration}`);
        const warnScreenName = `warn-screen-${nextIndex}`;
        const warnSceneName = `warn-${nextIndex}`;
        warningTl.add(warnSceneName);
        warningTl.add(warningTl.play(0), warnSceneName);
        tl.add(warnScreenName);
        tl.add(warningTl, warnScreenName);
        const questionTl = new TimelineMax({ paused: true })
            .to(this.questionsEl, 0.4, {
            autoAlpha: 1,
            onStart: () => {
                this.questionsEl.classList.remove('is-correct');
                this.questionsEl.classList.remove('is-wrong');
                this.questionsEl.classList.remove('is-dont-know');
                this.questionsEl.classList.remove('is-almost-right');
                this.questionsEl.classList.remove('is-almost-wrong');
            },
            onComplete: () => {
                this.questionsEl.classList.remove('is-message-shown');
                if (target) {
                    target.classList.remove("is-active");
                }
                this.timeline.container.classList.remove('is-choosed');
            }
        })
            .to(this.currentEl, 0.4, { y: '-100%' }, '-=0.4');
        const screenName = `question-screen-${nextIndex}`;
        const sceneName = ` question-${nextIndex}`;
        questionTl.add(sceneName);
        questionTl.add(questionTl.play(0), sceneName);
        tl.add(screenName);
        tl.add(questionTl, screenName);
        tl.play();
    }
    renderQuestions() {
        this.reset();
        const { config, items } = this.questions;
        const formattedConfig = config.reduce((res, item) => {
            const type = item.key.split(' + ')[1];
            if (res[type]) {
                return Object.assign(Object.assign({}, res), { [`${type}`]: {
                        key: type,
                        value: Number(res[type].value) + Number(item.value)
                    } });
            }
            return Object.assign(Object.assign({}, res), { [`${type}`]: item });
        }, {});
        const formattedConfigArr = Object.values(formattedConfig);
        const totalQuestionCount = formattedConfigArr.reduce((res, item) => res + Number(item.value), 0);
        const truthfulArr = new Array(totalQuestionCount).fill(0);
        truthfulArr.splice(0, 2, 1, 1);
        const truthfulShuffledArr = shuffleArray(truthfulArr);
        const truthfulArrMap = formattedConfigArr.reduce((res, item) => {
            const startsFrom = res.reduce((count, arr) => count + arr.length, 0);
            return [...res, truthfulShuffledArr.slice(startsFrom, startsFrom + Number(item.value))];
        }, []);
        const formattedQuestions = items.reduce((res, item, id) => {
            const type = item.type.split(' + ')[1];
            if (item.skip) {
                return Object.assign({}, res);
            }
            if (res[type]) {
                return Object.assign(Object.assign({}, res), { [`${type}`]: [...res[`${type}`], { id, item }] });
            }
            return Object.assign(Object.assign({}, res), { [`${type}`]: [{ id, item }] });
        }, {});
        console.log({ items, formattedQuestions });
        const questions = shuffleArray(formattedConfigArr.reduce((res, item, index) => {
            const shuffledQuestions = shuffleArray(formattedQuestions[item.key]);
            const usedIds = [];
            const questionBlock = truthfulArrMap[index].map((item) => {
                return shuffledQuestions.find(({ id, item: { value } }) => {
                    const isCorrect = (item === value) && !usedIds.includes(id);
                    if (isCorrect) {
                        usedIds.push(id);
                    }
                    return isCorrect;
                });
            });
            questionBlock.forEach(({ id }) => usedIds.push(id));
            return [...res, ...questionBlock];
        }, []));
        for (var i = 0; i < questions.length; i++) {
            this.questionIds[i] = questions[i].id;
        }
        this.renderAnswers(questions);
        this.questionsBlockEl.innerHTML = '';
        this.questionElements = null;
        this.questionElements = questions.map((question) => {
            const p = document.createElement("p");
            const span1 = document.createElement("span");
            const span2 = document.createElement("span");
            const span3 = document.createElement("span");
            span1.innerHTML = question.item.label;
            span2.innerHTML = question.item.label;
            span3.innerHTML = question.item.label;
            p.appendChild(span1);
            p.appendChild(span2);
            p.appendChild(span3);
            const container = document.createElement("div");
            container.dataset.value = question.item.value;
            container.appendChild(p);
            this.questionsBlockEl.appendChild(container);
            return container;
        });
        this.totalEl.innerHTML = questions.length.toString();
        if (this.timeline)
            this.timeline.setValues();
    }
    initQuestions() {
        fetch(this.url)
            .then((response) => response.json())
            .then((results) => {
            // TODO: add preloader
            /* eslint-disable-next-line */ /* @ts-ignore */
            const data = results[LANG];
            this.questions = data;
            this.renderQuestions();
        })
            .catch((error) => {
            throw new Error(error);
        });
    }
    initHandlers() {
        if (this.isHandlersInitialized) {
            return;
        }
        this.isHandlersInitialized = true;
        window.analytics.trackPage(`screen_1_question`);
        this.timeline.on("onValueUpdated", ({ data, target }) => {
            this.goNext(target, data);
        });
        this.timeline.on("onReset", () => {
            this.renderQuestions();
        });
        this.initQuestions();
    }
    init({ timeline, goToResults, particles }) {
        this.timeline = timeline;
        this.goToResults = goToResults;
        this.particles = particles;
        this.initHandlers();
        const tl = new TimelineMax({
            paused: true,
        }).staggerFromTo(this.animatedItems, 0.4, { autoAlpha: 0, y: 20 }, { autoAlpha: 1, y: 0 }, 0.2);
        tl.play();
    }
}
